




































import Vue from 'vue';

export default Vue.extend({
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    clearIcon: {
      type: String,
      default: 'cross',
    },
    disableClearButton: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    cityName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      width: window.innerWidth,
    };
  },
  computed: {
    inputRef(): HTMLInputElement {
      return this.$refs.input as HTMLInputElement;
    },
    dynamicPlaceholder(): string {
      if (this.width <= 429 && this.cityName != null) {
        return this.$t('10017503.Home_InputSearch');
      } else if (this.width <= 1023) {
        return this.$t('10017504.Home_InputSearchLong');
      }

      return this.placeholder;
    },
  },
  methods: {
    handleEnterPress(e: any): void {
      if (this.value?.length > 2) {
        this.blur();
      }
      this.$emit('submit', this.value);
    },
    handleClearClick(event: any): void {
      event.stopPropagation();
      this.$emit('onChange', event);
      this.$emit('onClear');
      this.triggerFilterCategory();
    },
    handleInput(event: any): void {
      this.$emit('onChange', event);
    },
    handleFocus(e: Event): void {
      this.$emit('focus', e);
    },
    handleBlur(): void {
      this.$emit('blur');
    },
    focus(): void {
      this.inputRef.focus();
    },
    blur(): void {
      this.inputRef.blur();
    },
    triggerFilterCategory(): void {
      var $activeTagCloudItem = $('#lastMinuteBox').find(
        '.tagcloud-inner:visible .tagcloud-item.active'
      );
      if ($activeTagCloudItem.length === 1) {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent('categorychange', false, false, {
          category: $activeTagCloudItem.data('category'),
        });
        window.dispatchEvent(evt);
      }
    },
    handleResize() {
      this.width = window.innerWidth;
    },
    triggerSuperDropdown(): void {
      // jQuery jank, because thats how SD works :D
      $('.super-dropdown-trigger').trigger('click.openDropdown');
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
});
